import React from 'react'
import PropTypes from 'prop-types'

// hixme-ui
import Container from '@hixme-ui/container'
import Title from '@hixme-ui/title'

import classes from './AppLoader.scss'

const AppLoader = ({ overlay }) => (
  <div className={overlay ? classes.overlay : classes.container}>
    <Container
      flex
      noPadding
      direction="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <div className={classes.loader} />
      <Title small thinnest white>
        Loading your data...
      </Title>
    </Container>
  </div>
)

AppLoader.displayName = 'AppLoader'
AppLoader.propTypes = {
  overlay: PropTypes.bool,
}
AppLoader.defaultProps = {
  overlay: false,
}

export default AppLoader
